import React, { useState, useEffect } from 'react';
import LayoutHeader from '../../../../../layout/LayoutHeader';
import searchImg from '../../../../../assets/images/components/search.png';
import { DizeeInput2 } from '../../../../../components/DizeeComponent/DixeeInput2';
import MusicCard from '../../../../../components/AddSection/Music/MusicCard';
import AddedMusicCard from '../../../../../components/AddSection/Music/AddedMusicCard';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getMusicThunk, searchMusicForReleaseThunk } from '../../../../../store/addsection/addsectionThunk';
import { clearAlerts } from '../../../../../store/alert/alertSlice';
import { ClipLoader } from 'react-spinners';
import { clearSearchMusic } from '../../../../../store/addsection/addsectionSlice';
import MusicOverlay from '../../../../../components/AddSection/Music/MusicOverlay';

export default function SearchForRelease() {
    const token = localStorage.getItem('dizeeToken');
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const musicLoading = useSelector((state) => state.addsection.musicLoading);
    const searchMusic = useSelector((state) => state.addsection.searchMusic);
    const music = useSelector((state) => state.addsection.music);
    const [isOverlayVisible, setOverlayVisible] = useState(false);
    const [avatarForBackend, setAvatarForBackend] = useState('');

    useEffect(() => {
        dispatch(clearAlerts())
        dispatch(getMusicThunk({ token }))
    }, [dispatch, token])

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 300); // Adjust the delay as needed

        return () => {
            clearTimeout(handler);
        };
    }, [search]);

    useEffect(() => {
        if (debouncedSearch.length < 6) {
            dispatch(clearSearchMusic());
            return;
        };
        dispatch(clearAlerts());
        dispatch(searchMusicForReleaseThunk({ token: token, search: debouncedSearch }));
        // }
    }, [debouncedSearch, dispatch, token]);

    // Enhanced sorting function that uses Songstats metrics
    const getSortedSearchResults = () => {
        if (!searchMusic || searchMusic.length === 0) return [];
        
        // Create a copy of the search results to sort
        return [...searchMusic].sort((a, b) => {
            // 1. Exact title match gets highest priority
            const searchLower = debouncedSearch.toLowerCase();
            const exactMatchA = a.title.toLowerCase() === searchLower;
            const exactMatchB = b.title.toLowerCase() === searchLower;
            
            if (exactMatchA && !exactMatchB) return -1;
            if (!exactMatchA && exactMatchB) return 1;
            
            // 2. If both or neither are exact matches, check if title starts with search term
            const startsWithA = a.title.toLowerCase().startsWith(searchLower);
            const startsWithB = b.title.toLowerCase().startsWith(searchLower);
            
            if (startsWithA && !startsWithB) return -1;
            if (!startsWithA && startsWithB) return 1;
            
            // 3. Use Songstats specific metrics
            // Check for total streams if available (Spotify, Apple Music, etc.)
            if (a.stats && b.stats) {
                // Get total streams across platforms if available
                const streamsA = 
                    (a.stats.spotify?.streams || 0) + 
                    (a.stats.apple_music?.plays || 0) + 
                    (a.stats.youtube?.views || 0) +
                    (a.stats.deezer?.plays || 0);
                
                const streamsB = 
                    (b.stats.spotify?.streams || 0) + 
                    (b.stats.apple_music?.plays || 0) + 
                    (b.stats.youtube?.views || 0) +
                    (b.stats.deezer?.plays || 0);
                
                if (streamsA !== streamsB) {
                    return streamsB - streamsA; // Higher streams first
                }
                
                // Check chart positions if available
                const chartPosA = a.stats.spotify?.chart_position || 999;
                const chartPosB = b.stats.spotify?.chart_position || 999;
                
                if (chartPosA !== chartPosB) {
                    return chartPosA - chartPosB; // Lower position number (higher rank) first
                }
                
                // Check playlist counts if available
                const playlistCountA = a.with_playlists?.length || 0;
                const playlistCountB = b.with_playlists?.length || 0;
                
                if (playlistCountA !== playlistCountB) {
                    return playlistCountB - playlistCountA; // More playlists first
                }
            }
            
            // 4. Check for verified/official artists
            const verifiedArtistA = a.artists?.some(artist => artist.verified);
            const verifiedArtistB = b.artists?.some(artist => artist.verified);
            
            if (verifiedArtistA && !verifiedArtistB) return -1;
            if (!verifiedArtistA && verifiedArtistB) return 1;
            
            // 5. Fallback to release date if available
            if (a.release_date && b.release_date) {
                return new Date(b.release_date) - new Date(a.release_date);
            }
            
            return 0;
        });
    };

    return (
        <LayoutHeader>
            <div className="w-[390px] h-[90vh] bg-black flex flex-col  items-center relative">
                {/* first div */}
                <div className='px-4 my-[50px] flex w-full justify-between'>
                    <p className='text-white' style={{ fontSize: '12px' }}>Search for a release</p>
                    <Link to="/add-section/add-music">
                        <p className='text-white cursor-pointer' style={{ fontSize: '12px' }}>Go back</p>
                    </Link>
                </div>
                {/* second div */}
                <div className='flex w-full flex-col gap-y-[50px] '>
                    <div className="flex flex-col justify-center items-center w-full">
                        <div className='p-4 pb-[40px] flex w-full justify-between items-center mt-[100px]' style={{ fontSize: '12px' }}>
                            <div className='items-center flex flex-row text-white w-full'>
                                <DizeeInput2
                                    placeholder="Search by song, album, URL, UPC or ISRC"
                                    className="dizee-input w-full"
                                    search={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                            <img src={searchImg} alt='sp' className='h-[12px] w-[12px] mx-1' />
                        </div>
                        {musicLoading ? (
                            <ClipLoader
                                color="white"
                                loading={true}
                                size={50}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        ) : (
                            searchMusic?.length > 0 &&
                            getSortedSearchResults().map((item, index) => {
                                const isExist = music.some(
                                    (song) => song.id === item.songstats_track_id
                                );
                                return (
                                    <MusicCard
                                        key={index}
                                        title={item.title}
                                        avatar={item?.avatar}
                                        artists={item?.artists[0]?.name}
                                        item={item}
                                        isExist={isExist}
                                    />
                                );
                            })
                        )}
                    </div>
                    {music?.length > 0 && (
                        <div className="flex flex-col justify-center items-center w-full">
                            <div className='p-4 pb-[40px] flex w-full justify-between items-center cursor-pointer' style={{ fontSize: '12px' }}>
                                <div className='items-center flex flex-row text-white w-full'>
                                    <p>Added Music</p>
                                </div>
                            </div>
                            {music.filter(item => {
                                // Filter out malformed entries
                                if (!item) return false;
                                if (item.publish && typeof item.publish === 'object' && !item.publish.value) return false;
                                return true;
                            }).map((item, index) => (
                                <AddedMusicCard
                                    key={index}
                                    music={item}
                                    setAvatarForBackend={setAvatarForBackend}
                                    setOverlayVisible={setOverlayVisible}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {isOverlayVisible && <MusicOverlay isOverlayVisible={isOverlayVisible}
                setOverlayVisible={setOverlayVisible} avatarForBackend={avatarForBackend} />}
        </LayoutHeader>
    );
}
